module.exports = __webpack_public_path__ + "img/report-problem.e7276fe3.svg";